import classNames from "classnames"
import dayjs from "dayjs"
import type { MouseEventHandler } from "react"
import { useMemo } from "react"
import { useGraphContext } from "../GraphContext"
import { useGetMgdlAsTopPosition } from "../useGetMgdlAsTopPosition"

import styles from "./GraphGlucoseDot.module.scss"

export interface Props {
  start: string;
  mgdl: number;
  date: string;
  className: string; // this should provide the color
  onClick?: () => void;
}

export function GraphGlucoseDot(props: Props) {
  const {
    start,
    mgdl,
    date,
    className,
    onClick,
  } = props

  const { pointsPerHour } = useGraphContext()
  const getMgdlAsTopPosition = useGetMgdlAsTopPosition()
  const [
    topPosition,
    clamped,
  ] = getMgdlAsTopPosition(mgdl)

  const left = dayjs(date)
    .diff(
      start,
      "hours",
      true,
    ) * pointsPerHour


  const computedStyles = {
    top: topPosition,
    left,
  }

  const readingClasses = useMemo(
    () => classNames(
      styles.reading,
      clamped && styles.clampedReading,
      className,
    ),
    [
      clamped,
      className,
    ],
  )

  const wrappedOnClick: MouseEventHandler | undefined = useMemo(
    () => !onClick ? undefined : (e) => {
      e.stopPropagation()

      onClick()
    },
    [onClick],
  )

  return (
    <button
      className={styles.container}
      style={computedStyles}
      onClick={wrappedOnClick}
      id="glucose-activity-icon"
    >
      <div
        className={readingClasses}
        id={"activity-graph-icon"}
      />
    </button>
  )
}
